'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnquirySourceContainerController = function () {
  function EnquirySourceContainerController(authService, enums, $stateParams, enquirySourcesManagementService, loadingService, $ngConfirm, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EnquirySourceContainerController);
    this.$stateParams = $stateParams;
    this.enquirySourcesManagementService = enquirySourcesManagementService;
    this.loadingService = loadingService;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;

    this.enquirySources = [];
    this.initializeEnquirySources();

    this.state = '';
    this.resetNotification();
  }

  (0, _createClass3.default)(EnquirySourceContainerController, [{
    key: 'resetNotification',
    value: function resetNotification() {
      this.notification = {
        type: '',
        msg: ''
      };
    }
  }, {
    key: 'initializeEnquirySources',
    value: function initializeEnquirySources() {
      var ctrl = this;

      ctrl.loadingService.showLoading('enquirySourcesList', 'Loading Enquiry Sources ...');

      ctrl.enquirySourcesManagementService.list(ctrl.$stateParams.locationId, false).then(function (response) {
        ctrl.enquirySources = response.data;
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquirySourcesList');
      });
    }
  }, {
    key: 'showAdd',
    value: function showAdd() {
      var _this = this;

      this.$scope.errMsg = null;

      this.$scope.tempSource = {
        name: null,
        spend: null
      };

      this.$ngConfirm({
        title: 'Add Enquiry Source',
        contentUrl: 'templates/admin/editEnquirySourceTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              if (!_this.$scope.tempSource.name) {
                _this.$scope.errMsg = "Please enter a name";
                return false;
              }

              _this.addEnquirySource();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'showEdit',
    value: function showEdit(src) {
      var _this2 = this;

      this.$scope.errMsg = null;

      this.$scope.tempSource = {
        enquirySourceId: src.enquirySourceId,
        name: src.name,
        spend: src.spend
      };

      this.$ngConfirm({
        title: 'Update Enquiry Source',
        contentUrl: 'templates/admin/editEnquirySourceTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              _this2.updateEnquirySource();
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'validateAddEnquirySource',
    value: function validateAddEnquirySource(name) {
      var ctrl = this;

      ctrl.resetNotification();

      if (!name || name.length < 3 || name.length > 40) {
        ctrl.notification = {
          type: 'error',
          msg: 'Name is required field and must be between 3 and 40 characters'
        };

        return false;
      } else if ((0, _lodash.find)(ctrl.enquirySources, function (e) {
        return e.name.toLowerCase() === name.toLowerCase();
      })) {
        ctrl.notification = {
          type: 'error',
          msg: name + ' is already added to the list'
        };

        return false;
      }

      return true;
    }
  }, {
    key: 'addEnquirySource',
    value: function addEnquirySource() {
      var _this3 = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('enquirySourcesList', 'Adding Enquiry Source ...');

      ctrl.enquirySourcesManagementService.add(ctrl.$stateParams.locationId, ctrl.$scope.tempSource).then(function (response) {
        ctrl.initializeEnquirySources();
      }).catch(function (err) {
        _this3.notification = {
          type: 'error',
          msg: 'An error occurred while adding source'
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquirySourcesList');
      });
    }
  }, {
    key: 'updateEnquirySource',
    value: function updateEnquirySource() {
      var _this4 = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('enquirySourcesList', 'Updating Enquiry Source ...');

      ctrl.enquirySourcesManagementService.update(ctrl.$stateParams.locationId, this.$scope.tempSource).then(function (response) {
        ctrl.initializeEnquirySources();
      }).catch(function (err) {
        _this4.notification = {
          type: 'error',
          msg: 'An error occurred while updating source'
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquirySourcesList');
      });
    }
  }, {
    key: 'removeEnquirySource',
    value: function removeEnquirySource(src) {
      var _this5 = this;

      var ctrl = this;
      ctrl.initializeEnquirySources();

      var sure = confirm('Are you sure you want to delete this enquiry source. ' + src.name);

      if (!sure) {
        return;
      }

      ctrl.loadingService.showLoading('enquirySourcesList', 'Removing Enquiry Source ...');

      ctrl.enquirySourcesManagementService.delete(ctrl.$stateParams.locationId, src.enquirySourceId).then(function (response) {
        ctrl.notification = {
          type: 'success',
          msg: 'Source removed successfully'
        };

        ctrl.initializeEnquirySources();
      }).catch(function (err) {
        _this5.notification = {
          type: 'error',
          msg: 'An error occurred while removed source'
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquirySourcesList');
      });
    }
  }, {
    key: 'toggleEnabled',
    value: function toggleEnabled(enquirySourceId) {
      var _this6 = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('enquirySourcesList', 'Updating Enquiry Source ...');

      ctrl.enquirySourcesManagementService.toggleEnabled(ctrl.$stateParams.locationId, enquirySourceId).then(function (response) {
        ctrl.notification = {
          type: 'success',
          msg: 'Source updated successfully'
        };
      }).catch(function (err) {
        _this6.notification = {
          type: 'error',
          msg: 'An error occurred while adding source'
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('enquirySourcesList');
      });
    }
  }]);
  return EnquirySourceContainerController;
}();

exports.default = EnquirySourceContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/enquirySourceManagement/enquirySourceContainer/enquirySourceContainer.controller.js